'use client';

import { useEffect, useRef, useState } from 'react';

import { useRateBooking } from '@website/context/RateBookingContext';

/**
 * Bumps a key when the rate-booking drawer/modal closes so `RateMentorCard` remounts
 * and clears its local star selection (user dismissed without finishing).
 */
export function useRateMentorCardResetKey(): number {
  const { isOpen } = useRateBooking();
  const [key, setKey] = useState(0);
  const wasOpenRef = useRef(false);

  useEffect(() => {
    if (wasOpenRef.current && !isOpen) {
      setKey((k) => k + 1);
    }
    wasOpenRef.current = isOpen;
  }, [isOpen]);

  return key;
}
